<template>
    <div class="aliVideo">
        <div id="J_prismPlayer" class="J_prismPlayer"></div>
    </div>
</template>

<script>
export default {
    name: 'aliVideo',
    props: ['mediaUrl'],
    data() {
        return {}
    },
    mounted() {
        if (this.mediaUrl) {
            var player = new Aliplayer(
                {
                    id: 'J_prismPlayer',
                    width: '100%',
                    height: '100%',
                    source: this.mediaUrl,
                    autoplay: true,
                    rePlay: true,
                    autoplayPolicy: { fallbackToMute: true },
                    useH5Prism: true,
                    isLive: false,
                },
                function (player) {
                    console.log('The player is created.')
                }
            )
        }
    },
    methods: {},
}
</script>

<style lang="less" scoped>
.aliVideo {
    width: 100%;
    height: 100%;

    .J_prismPlayer {
        width: 100%;
        height: 100%;
    }
}
</style>
